import * as React from 'react';

function SvgPlay(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M5.315 22c-.333 0-.661-.088-.95-.254-.653-.37-1.058-1.087-1.058-1.866V4.12c0-.781.405-1.497 1.057-1.866a1.91 1.91 0 011.944.024l13.47 8.063a1.956 1.956 0 010 3.316L6.306 21.722c-.299.18-.641.277-.99.278z" })));
}

export default SvgPlay;
